import { AbstractControl, ValidatorFn } from '@angular/forms';
import { PasswordComplexitySettings } from '../../../admin/core/models/user.model';

export class PasswordStrengthValidator {

  static validate(settings: PasswordComplexitySettings): ValidatorFn {
    return (inputControl: AbstractControl): { [key: string]: boolean } | null => {

      let value = inputControl.value;

      if (settings.requiredLength && value.length < settings.requiredLength)
        return { 'requireLength': true };

      if (settings.requireUppercase && !/[A-Z]/.test(value))
        return { 'requireUppercase': true };

      if (settings.requireLowercase && !/[a-z]/.test(value))
        return { 'requireLowercase': true };

      if (settings.requireDigit && !/\d/.test(value))
        return { 'requireDigit': true };

      if (settings.requireNonAlphanumeric && !/[!@#$%^&*,.]/.test(value))
        return { 'requireSpecialCharacter': true };

      return null;
    };
  }
}
